export function stripProtocol(value) {
  if (value) return value.replace(/^(https?:\/\/)/g, '');
  return '';
}

export function normalizeUrl(value) {
  if (value) return `https://${stripProtocol(value)}`;
  return '';
}
